function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.25,
  fill: "#C4C4C4",
  stroke: "#4860CF",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_131_97254)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.9508 47C37.9508 57.6798 29.8676 66.25 20.0008 66.25C10.134 66.25 2.05078 57.6798 2.05078 47C2.05078 36.3202 10.134 27.75 20.0008 27.75C29.8676 27.75 37.9508 36.3202 37.9508 47Z",
  stroke: "#4860CF",
  strokeWidth: 1.5
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 17,
  r: 6.25,
  stroke: "#4860CF",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.25,
  stroke: "#353755",
  strokeWidth: 1.5
});

function SvgMyprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_97254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _ref2), _ref3, _ref4, _ref5);
}

var ForwardRef = React.forwardRef(SvgMyprofile);
export default __webpack_public_path__ + "static/media/myprofile.83030ac3.svg";
export { ForwardRef as ReactComponent };